export var departamentMixin = {
        data : () => {
            return {
                departamentQuery: {codigo: '', descricao: '', classificacao: '',  page: 1, todos: null},
                selectedHeaderOptions : [{
                    text:'CODIGO',
                    value:'CODIGO'
                },
                {
                    text: 'DESCRICAO',
                    value: 'DESCRICAO'
                },
                {
                    text: 'CLASSIFICACAO',
                    value: 'CLASSIFICACAO'
                },
                {
                    text: 'Ações',
                    value: "controls",
                    align: 'right'
                }],
            }
        },
}

